export const LoadingCard = () => (
    <div className="w-full max-w-2xl mx-auto mt-6">
        <div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
        <div className="px-5 py-4 border-b bg-gray-50">
            <div className="h-5 w-44 bg-gray-200 rounded animate-pulse" />
            <div className="h-4 w-32 bg-gray-200 rounded mt-2 animate-pulse" />
        </div>
        <div className="p-6">
            <div className="h-64 bg-gray-100 rounded-lg animate-pulse" />
        </div>
        </div>
    </div>
);

export const EmptyCard = (props) => {
    const { title, subtitle } = props;
    return (
        <div className="w-full max-w-2xl mx-auto mt-6">
            <div className="rounded-xl border border-gray-200 bg-white shadow-sm p-6">
            <div className="text-gray-900 font-semibold">{title}</div>
            <div className="text-sm text-gray-600 mt-1">{subtitle}</div>
            </div>
        </div>
    );
};

export const TooltipCard = (props) => {
    const { active, payload } = props;
    if (!active || !payload?.length) return null;
    const d = payload[0]?.payload;
    if (!d) return null;
    return (
        <div className="bg-white border border-gray-200 rounded-lg shadow-lg px-3 py-2">
        <div className="text-sm font-semibold text-gray-900">{d.name}</div>
        <div className="text-xs text-gray-600 mt-1">
            <span className="font-medium text-gray-900">{d.value}</span> games •{" "}
            <span className="font-medium text-gray-900">{d.pct.toFixed(1)}%</span>
        </div>
        </div>
    );
};